const features = [
  {
    icon: 'ri-shield-check-line',
    title: '官方认证',
    description: '所有域名均经过官方认证，确保安全可靠，杜绝假冒钓鱼网站的风险，为您提供最安全的访问保障。',
  },
  {
    icon: 'ri-refresh-line',
    title: '实时更新',
    description: '团队24小时监控域名状态，一旦发现失效立即更新，确保您始终能获取到最新的可用域名。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '全球加速',
    description: '部署全球CDN加速节点，无论您身在何处，都能享受高速流畅的访问体验，告别卡顿烦恼。',
  },
  {
    icon: 'ri-links-line',
    title: '多域名备份',
    description: '提供多个备用域名地址，主域名不可用时自动切换，确保在任何网络环境下都能畅通访问。',
  },
  {
    icon: 'ri-lock-line',
    title: '隐私安全',
    description: '采用先进的加密技术保护您的访问隐私，不记录任何用户行为数据，让您安心浏览。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '专属客服',
    description: '提供7×24小时在线客服支持，遇到任何访问问题都能第一时间获得专业的技术协助。',
  },
];

export default function Features() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-800 text-xs font-medium rounded-full mb-4">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            六大<strong className="text-primary-600">核心优势</strong>
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            我们致力于为用户提供最稳定、最安全、最高速的域名导航服务，让您随时畅享黑料网的精彩内容。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 hover:border-secondary-300/50 transition-all duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-secondary-100 rounded-lg mb-4">
                <i className={`${feature.icon} text-lg text-secondary-600`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}